import Cookies from 'js-cookie'
import md5 from 'md5'
import { YJJ_ENV } from '../config'
let env_str = 'yjjpc_' + md5(location.host + YJJ_ENV).slice(0, 4) + '_'
export const cookiesList = {
  userType: env_str + 'user_type',
  token: env_str + 'token',
  userId: env_str + 'user_id',
  phone: env_str + 'user_account'
}

export function setCookie (key, value) {
  return Cookies.set(key, value, { expires: 7 })
}

export function getCookie (key) {
  return Cookies.get(key)
}

export function removeCookie (key) {
  return Cookies.remove(key)
}

export function clearLoginData () {
  for (let key in cookiesList) {
    Cookies.remove(cookiesList[key])
  }
}

export function getToken() {
  return Cookies.get(cookiesList.token)
}

export function setToken() {
  return Cookies.set(cookiesList.token)
}

export function removeToken() {
  return Cookies.remove(cookiesList.token)
}
